// extracted by mini-css-extract-plugin
module.exports = {"emailBox":"emailBox_emailBox__kaye7","popupModal":"emailBox_popupModal__b728S"};